import { NgModule } from '@angular/core';


import { HomePageModule } from './home/home.module';
import { PostPageModule } from './post/post.module';
import { LoginPageModule } from './login/login.module'; 
import { WritePageModule } from './write/write.module';
import { NotFoundExceptionPageModule } from './not-found-exception-page/not-found-exception-page.module';
import { ErrorPageModule } from './error-page/error-page.module';


@NgModule({
  imports: [
    HomePageModule,
    PostPageModule,
    LoginPageModule,
    WritePageModule,
    NotFoundExceptionPageModule,
    ErrorPageModule
  ],exports: [
  	HomePageModule,
  	PostPageModule,
  	LoginPageModule,
  	WritePageModule,
  	NotFoundExceptionPageModule,
    ErrorPageModule
  ]
})
export class PagesModule { }
